import React, { useState, useCallback, useRef, useEffect } from "react";

import { Offcanvas } from "react-bootstrap";
import useApiServices from "../../utils/useApiServices";
import {
  DISABLE_WHITELIST_RULE,
  GET_WHITELIST_AMOUNT_RULES_SID,
  ENABLE_DISABLE_RULE_SID,
  GET_FRM_AMOUNT_RULES_SID,
} from "../../utils/constant";
import swal from "sweetalert";
import { DataGrid } from "@mui/x-data-grid";

const DragDropRules = ({
  showRule,
  setShowRule,
  id,
  getAllMerchantsWithTheirRules,
  viewOnly,
  type,
}) => {
  console.log(id);
  const [data, setData] = useState([]);

  const { apiCallFnforGet, apiCallFnforPut, apiCallFnforPost } =
    useApiServices();

  const FetchDataForRules = async () => {
    const response = await apiCallFnforGet(
      type === "FRM"
        ? GET_FRM_AMOUNT_RULES_SID + id
        : `${GET_WHITELIST_AMOUNT_RULES_SID}/${id?.id}`
    );

    if (response?.statusCode === 200) {
      setData(
        response?.data?.map((item) => {
          return {
            ...item,
            id: item?.ruleId,
          };
        })
      );
    }
  };

  useEffect(() => {
    FetchDataForRules();
  }, []);

  const columns = [
    {
      headerName: "MID",
      field: "mid",
      flex: 1,
    },
    {
      headerName: "SID",
      field: "sid",
      flex: 1,
    },
    ...(type !== "FRM"
      ? [
          {
            headerName: "Rule Name",
            field: "ruleName",
            flex: 1,
          },
        ]
      : []),
    {
      headerName: "Domain",
      field: "domain",
      flex: 1,
    },
    {
      headerName: "Processor",
      field: "processor",
      flex: 1,
    },
    {
      headerName: "Action",
      field: "action",
      flex: 1,
      renderCell: (params) =>
        !viewOnly && (
          <div className="w-100 d-flex align-items-center gap-2 mt-1">
            <button
              className="btn btn-danger btn-sm"
              onClick={() => handleRuleDelete(params.row.ruleId)}
            >
              Delete
            </button>
            <button
              className={`btn btn-sm ${
                params?.row?.active ? "btn-danger" : "btn-success"
              }`}
              onClick={() =>
                handleToggleActive(params?.row?.ruleId, !params?.row?.active)
              }
            >
              {params.row.active ? "Disable" : "Enable"}
            </button>
          </div>
        ),
    },
  ];

  const handleRuleDelete = async (id) => {
    try {
      swal({
        title: "Alert",
        text: `Are you sure, you want to Delete this rule ?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDisable) => {
        if (willDisable) {
          const response = await apiCallFnforPut(DISABLE_WHITELIST_RULE + id);

          if (response.statusCode === 200) {
            swal({
              title: "Success",
              text: response.message,
              icon: "success",
            });
            setTimeout(() => {
              FetchDataForRules();
            }, 1000);
          } else {
            swal({
              title: "Alert",
              text: response.message,
              icon: "error",
            });
          }
        } else {
        }
      });
    } catch (error) {
      swal({
        title: "Alert",
        text: error,
        icon: "error",
      });
    }
  };

  const handleToggleActive = async (id, active) => {
    try {
      swal({
        title: "Alert",
        text: `Are you sure, you want to ${
          active ? "Disable" : "Enable"
        }  this rule?`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDisable) => {
        if (willDisable) {
          const response = await apiCallFnforPost(
            `${ENABLE_DISABLE_RULE_SID}/${id}/${active}`
          );

          if (response.statusCode === 200) {
            swal({
              title: "Success",
              text: response.message,
              icon: "success",
            });
            setTimeout(() => {
              FetchDataForRules();
            }, 1000);
          } else {
            swal({
              title: "Alert",
              text: response.message,
              icon: "error",
            });
          }
        } else {
        }
      });
    } catch (error) {
      swal({
        title: "Alert",
        text: error,
        icon: "error",
      });
    }
  };

  const offcanvasStyle = {
    width: "90vw", // Set width to 70vw
  };

  const handleClose = () => {
    setShowRule(false);
  };

  return (
    <>
      <Offcanvas
        show={showRule}
        onHide={handleClose}
        placement="end"
        style={offcanvasStyle}
        backdrop="static"
        keyboard={false}
      >
        <div className="d-flex justify-content-start align-items-center">
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <h5
            class="offcanvas-title  fs-2 text-dark fw-bold"
            id="offcanvasLabel"
          >
            {type} Routing Rule Wise
          </h5>
        </div>
        <Offcanvas.Body>
          <div className="overflow-x-scroll">
            {/* <DndProvider backend={HTML5Backend}> */}
            <DataGrid
              rows={data}
              columns={columns}
              pagination={false}
              autoHeight
            />
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DragDropRules;
